import { isMobile, isTablet, WithBreakpointRange } from '@mews-commander/ui';
import { Container, Grid, withBreakpointRange, WithChildren } from '@optimus-web/core';

const ExtraFundingLayoutComponent: React.FC<WithBreakpointRange & WithChildren> = ({ children, breakpointRange }) => (
    <Container
        padding={[
            (isMobile(breakpointRange) && '700') || '1200',
            (isMobile(breakpointRange) && '200') || (isTablet(breakpointRange) && '300') || '900',
        ]}
    >
        <Grid
            templateColumns="1fr 1fr"
            gap={(isTablet(breakpointRange) && '1200') || '400'}
            largePhoneMax={{ templateColumns: '1fr' }}
        >
            {children}
        </Grid>
    </Container>
);

export const ExtraFundingLayout = withBreakpointRange(ExtraFundingLayoutComponent);
